import { Injectable, Injector, signal } from '@angular/core';
import { EmployeeService } from '../../services/employee-service/employee-service.service';
import { catchError, finalize, map, of } from 'rxjs';
import { AuthenticationFeatureService } from '../authentication-feature/authentication-feature.service';
import { Employee } from '../../domain/employee-domain';

@Injectable({
  providedIn: 'root',
})
export class EmployeeFeatureService {
  isLoadingEmployee = signal<boolean>(false);
  employee = signal<Employee | null>(null);

  constructor(
    private employeeService: EmployeeService,
    private injector: Injector,
  ) {}

  validateEmployeeAccount() {
    const _authFeature = this.injector.get(AuthenticationFeatureService);
    this.isLoadingEmployee.set(true);
    const account = _authFeature.getInstance().getActiveAccount();

    return this.employeeService.fetchEmployeeList().pipe(
      map((employeeRoot) => {
        const employee = employeeRoot.value.find((e) => e.email.toLowerCase() === account?.username.toLowerCase()) ?? null;
        this.employee.set(employee);
      }),
      catchError(() => {
        this.employee.set(null);
        return of(null);
      }),
      finalize(() => this.isLoadingEmployee.set(false)),
    );
  }

  isEmployeeValidated(): boolean {
    return this.employee() != null;
  }

  getEmployeeNo() {
    return this.employee()?.number ?? null;
  }
}
